export const verifNumber = (search: string): boolean => {
  return /^\d+$/.test(search);
};

export const verifName = (search: string): boolean => {
  return /^[,---a-zA-Zàâçéèêëîïôûùüÿñæœ']+$/.test(search);
};

export const verifClaimNumber = (search: string): boolean => {
  return /^\d+$/.test(search) && search.length === 10;
};

export const verifadhesionNumber = (search: string): boolean => {
  return /^\d+$/.test(search) && search.length === 12;
};

export const verifEmail = (email: string): boolean => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};
